import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Image } from '@blueprint/image';
import { Text } from '@blueprint/ui';
import { ShareSmall, ShareiosSmall } from '@blueprint/icons';

export const SavedListingCardFooter = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: row;
        height: 4.25rem;
        justify-content: space-between;
        padding: 0.75rem ${spacing['16px']};
    `
);

export const StyledBranchLogo = styled(Image)(
    ({ theme: { spacing } }) => css`
        height: 2.5rem;
        margin-right: ${spacing['16px']};
        width: auto;
    `
);

export const ListedOn = styled(Text)();

export const FooterSection = styled('div')(css`
    align-items: center;
    display: flex;
    flex-direction: row;
`);

export const ShareSmallColored = styled(ShareSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);

export const ShareiosSmallColored = styled(ShareiosSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);
